import _ from 'lodash';

import { CLIENT_CREATE, CLIENT_DELETE, CLIENT_LIST, CLIENT_READ, CLIENT_RESET, CLIENT_UPDATE, CLIENT_WINE_LIST, CLIENT_WINE_SET, CLIENT_WINE_UNSET, CLIENT_WINE_UPDATE } from '@/store/actions/client';
import { GROUP_LIST } from '@/store/actions/group';
import { PRODUCER_LIST } from '@/store/actions/producer';

import clientApi from '@/api/client';
import wineApi from '@/api/wine';
import { color2text } from '@/filters';
import { wineSort } from '@/sorters';

/* eslint-disable camelcase */


const state = {
  clients: [],
  wines: [],

  client: {
    client_id: null,
    group_id: null,
    name: null,
    address: {
      address: null,
      zipCode: null,
      city: null,
      country: null
    },
    phone_number: null,
    contact_name: null,
    email: null,
    contract: null,
    discount: null,
    type: null,
    /* BILLING */
    company_name: null,
    legal_form: null,
    siret: null,
    vat_number: null,
    ape_code: null,
    iban: null,
    bic: null,
    devise: null,
    website_url: null,
    lang: null,
    /* USER */
    username: null,
    password: null
  },
  defaultItem: {
    client_id: null,
    group_id: null,
    name: null,
    address: {
      address: null,
      zipCode: null,
      city: null,
      country: null
    },
    phone_number: null,
    contact_name: null,
    email: null,
    contract: null,
    discount: null,
    type: null,
    /* BILLING */
    company_name: null,
    legal_form: null,
    siret: null,
    vat_number: null,
    ape_code: null,
    iban: null,
    bic: null,
    devise: null,
    website_url: null,
    lang: null,
    /* USER */
    username: null,
    password: null
  }
};

const getters = {
  getClientById: (state) => (id) => {
    return state.clients.find(c => c.client_id === id) || state.defaultItem;
  }
};

const actions = {
  async [CLIENT_LIST] ({ commit, dispatch }) {
    await dispatch(GROUP_LIST);

    commit(CLIENT_LIST, await clientApi.getClients());
  },

  async [CLIENT_CREATE] ({ commit }, data) {
    commit(CLIENT_CREATE, await clientApi.createClient(data));
  },

  async [CLIENT_READ] ({ commit, state }, id) {
    if (state.client.client_id !== id) {
      commit(CLIENT_READ, { client_id: id });
      commit(CLIENT_READ, await clientApi.getClient(id));
    }
  },

  async [CLIENT_RESET] ({ commit, state }) {
    commit(CLIENT_READ, state.defaultItem);
  },

  async [CLIENT_UPDATE] ({ commit }, data) {
    commit(CLIENT_UPDATE, Object.assign({}, data, await clientApi.updateClient(data)));
  },

  async [CLIENT_DELETE] ({ commit }, id) {
    await clientApi.deleteClient(id);
    commit(CLIENT_DELETE, id);
  },


  async [CLIENT_WINE_LIST] ({ commit, dispatch, getters }, id) {
    await dispatch(CLIENT_READ, id);
    await dispatch(PRODUCER_LIST);

    let wines = await wineApi.getWines();
    let enabledWines = await clientApi.getClientWines(id);

    for (let w of wines) {
      let p = getters.producerById(w.producer_id);
      w._producer_name = p ? p.name : '';
      w._color_name = color2text(w.color);
      w._enabled = enabledWines.findIndex(elt => elt === w.wine_id) !== -1;
    }

    // Sort
    wineSort(wines);

    commit(CLIENT_WINE_LIST, wines);
  },

  async [CLIENT_WINE_SET] ({ commit, dispatch }, wine_id) {
    commit(CLIENT_WINE_SET, wine_id);

    await dispatch(CLIENT_WINE_UPDATE);
  },

  async [CLIENT_WINE_UNSET] ({ commit, dispatch }, wine_id) {
    commit(CLIENT_WINE_UNSET, wine_id);

    await dispatch(CLIENT_WINE_UPDATE);
  },

  async [CLIENT_WINE_UPDATE] ({ state }) {
    await clientApi.putClientWines(state.client.client_id, state.wines.reduce((acc, elt) => {
      if (elt._enabled) {
        acc.push(elt.wine_id);
      }
      return acc;
    }, []));
  }
};

const mutations = {
  [CLIENT_LIST] (state, clients) {
    state.clients = clients;
  },

  [CLIENT_CREATE] (state, client) {
    state.clients.push(client);
  },

  [CLIENT_READ] (state, client) {
    state.client = _.merge({}, state.defaultItem, client);
  },

  [CLIENT_UPDATE] (state, client) {
    const idx = state.clients.findIndex(elt => elt.client_id === client.client_id);
    state.clients.splice(idx, 1, client);
  },

  [CLIENT_DELETE] (state, id) {
    const idx = state.clients.findIndex(elt => elt.client_id === id);
    if (idx !== -1) {
      state.clients.splice(idx, 1);
    }
  },


  [CLIENT_WINE_LIST] (state, wines) {
    state.wines = wines;
  },

  [CLIENT_WINE_SET] (state, wine_id) {
    const idx = state.wines.findIndex(elt => elt.wine_id === wine_id);
    if (idx !== -1) {
      state.wines[idx]._enabled = true;
    }
  },

  [CLIENT_WINE_UNSET] (state, wine_id) {
    const idx = state.wines.findIndex(elt => elt.wine_id === wine_id);
    if (idx !== -1) {
      state.wines[idx]._enabled = false;
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
